import { render, staticRenderFns } from "./Alignment.vue?vue&type=template&id=361248c5&scoped=true&"
import script from "./Alignment.vue?vue&type=script&lang=js&"
export * from "./Alignment.vue?vue&type=script&lang=js&"
import style0 from "./Alignment.vue?vue&type=style&index=0&id=361248c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361248c5",
  null
  
)

export default component.exports